import type { QueryClient } from "@tanstack/react-query";
import type { DashboardOverview } from "@/api/types";
import {
  currentDashboardSlug,
  dashboardRequestOptions,
  dashboardRequestOptionsForSlug,
  useDashboardActiveSlug,
} from "@/lib/dashboard-context";

export function dashboardQueryKeyForSlug(slug: string | undefined, ...parts: readonly unknown[]) {
  return ["dashboard", slug ?? "selected", ...parts] as const;
}

export function useDashboardRequest(slugOverride?: string) {
  const activeSlug = useDashboardActiveSlug();
  const slug = slugOverride ?? activeSlug ?? currentDashboardSlug();

  return {
    slug,
    queryKey: (...parts: readonly unknown[]) => dashboardQueryKeyForSlug(slug, ...parts),
    requestOptions: () => dashboardRequestOptionsForSlug(slug),
  };
}

export function businessSlugFromOverview(
  queryClient: QueryClient,
  slugOverride?: string,
): string | undefined {
  const slug = slugOverride ?? currentDashboardSlug();

  return (
    queryClient.getQueryData<DashboardOverview>(dashboardQueryKeyForSlug(slug, "overview"))
      ?.business.slug ?? slug
  );
}

export { dashboardRequestOptions };
